<template>
    <div>
        <v-toolbar card dark color="primary" class="cabecalho" style="margin-top: 20px !important;">
            <button class="v-btn v-btn--depressed v-btn--flat botao-voltar text-uppercase" @click="$emit('voltar')">
                <i class="fas fa-arrow-left mr-2" aria-hidden="true"/>
                <span class="texto">Voltar</span>
            </button>

            <div class="cabecalho__texto">
                <div class="cabecalho__info">
                    <p>
                        <strong>Nº Processo</strong><br>
                        {{ numeroProcesso ? numeroProcesso : '--' }}
                    </p>
                    <p>
                        <strong>{{ $t('main.comprador_analise_documentacao_cabecalho_orgao.text') }}</strong><br>
                        {{ orgao ? orgao : '--' }}
                    </p>
                </div>

                <div class="cabecalho-mobile__titulo">
                    <p>Compra Direta</p>
                </div>

                <salvamento-automatico class="mr-2"/>

                <button class="cabecalho-mobile__botao" @click="exibirInformacoes">
                    <i class="fas fa-file" aria-hidden="true"/>
                </button>
            </div>
        </v-toolbar>

        <div v-if="exibirInformacoesMobile" class="cabecalho-mobile__info">
            <p>
                <strong>Nº Processo</strong>
                {{ numeroProcesso ? numeroProcesso : '--' }}
            </p>
            <p>
                <strong>{{ $t('main.comprador_analise_documentacao_cabecalho_orgao.text') }}</strong>
                {{ orgao ? orgao : '--' }}
            </p>
        </div>
    </div>
</template>

<script>
import SalvamentoAutomatico from '@/views/components/SalvamentoAutomatico'

export default {
    name: 'DocumentosCompraDiretaCabecalho',
    components: {SalvamentoAutomatico},
    props: {
        numeroProcesso: {
            type: String,
            default: null
        },
        orgao: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            exibirInformacoesMobile: false
        }
    },
    methods: {
        exibirInformacoes() {
            this.exibirInformacoesMobile = !this.exibirInformacoesMobile
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-voltar
        margin 0 !important
        width 120px
        background-color var(--v-primary-base)
        border-right 1px solid rgba(255, 2555, 2555, .5)
        font-size 12px

    .cabecalho
        position fixed
        z-index 999
        box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

        &__texto
            justify-content space-between
            width 93%
            align-items center
            font-size 12px

            p
                margin 0 20px
                line-height 13px

        &__info, &__texto
            display flex

        &-mobile
            &__botao
                display none
                height 48px
                width 50px
                font-size 16px
                background-color var(--v-primary-darken1)

                &:hover, &:active, &:focus
                    background-color var(--v-primary-darken2)
                    outline 0

            &__info
                padding 54px 0 0
                margin 0
                font-size 13px
                color #777
                display none
                -webkit-transition all 1s cubic-bezier(0, 1, .5, 1)
                -moz-transition all 1s cubic-bezier(0, 1, .5, 1)
                -ms-transition all 1s cubic-bezier(0, 1, .5, 1)
                transition all 1s cubic-bezier(0, 1, .5, 1)
                z-index 2
                position fixed
                background-color #fff
                width 100%
                box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

                p
                    margin-bottom 0
                    border-style solid
                    border-width 0 1px 1px
                    border-color #ebebeb
                    padding 10px
                    display flex
                    justify-content space-between
                    text-align right

                strong
                    margin-right 10px

            &__titulo
                font-size 14px
                font-weight 600
                display none
                margin 0 auto
                text-transform uppercase

    @media(max-width 1430px)
        .cabecalho__texto
            width 100%
            flex-wrap wrap

    @media(max-width 1200px)
        .cabecalho__texto p
            margin 0 10px

        .botao-voltar
            padding 0
            margin 0 !important
            flex 0

        .cabecalho__texto, .botao-voltar
            font-size 11px

    @media(max-width 500px)
        .cabecalho
            &__info, .botao-voltar .texto
                display none

            &-mobile__botao, &-mobile__info, &-mobile__titulo
                display block

            .botao-voltar
                font-size 16px
                border-right 0
                min-width 60px

            &-mobile__botao
                height 56px
</style>
